import { initialState, TemplateDetailState, templateDetailAdapter } from './template-detail.interfaces';
import * as fromTemplateDetail from './template-detail.actions';
export function reducer(state = initialState, action: fromTemplateDetail.TemplateDetailAction): TemplateDetailState {
  switch (action.type) {
    case fromTemplateDetail.GET_TEMPLATE_DETAIL_FROM_SERVER: {
      return {
        ...state,
        error: null,
      };
    }
    case fromTemplateDetail.GET_TEMPLATE_DETAIL_FROM_SERVER_SUCCESS: {
      return {
        ...templateDetailAdapter.addMany(action.payload.templateDetail, state),
        error: null,
      };
    }

    case fromTemplateDetail.GET_TEMPLATE_DETAIL_FROM_SERVER_FAILURE: {
      return {
        ...state,
        error: String(action.payload.error),
      };
    }
    case fromTemplateDetail.CLEAR_TEMPLATE_DETAIL_IN_STATE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
